import { MsalProvider } from '@azure/msal-react'
import { Auth0Provider } from '@auth0/auth0-react'
import { msalInstance } from 'hooks/useAuth'
import { FC } from 'react'
import { authIsAd } from './AuthProvider'

export const AuthProviderWrapper: FC = ({ children }) => {
  if (authIsAd() || window.Cypress) {
    return <MsalProvider instance={msalInstance}>{children}</MsalProvider>
  }
  return (
    <Auth0Provider
      domain={window.appConfig.AUTH0_DOMAIN}
      clientId={window.appConfig.AUTH0_CLIENT_ID}
      redirectUri={
        window.appConfig.REDIRECT_URI || window.appConfig.AD_REDIRECT_URI
      }
      audience={window.appConfig.AUTH0_AUDIENCE}
      useRefreshTokens
      cacheLocation='localstorage'>
      {children}
    </Auth0Provider>
  )
}
